import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {getGroupedShapesByColor} from "../../../helpers/sqftDataMapper";

const SqftSummaryFeatureColors = (props) => {
  const {intl} = props;
  void intl;
  const colorSets = getGroupedShapesByColor();

  return (
    colorSets.map((colorSet, index) => {
      return (
        <div className="summary-list__item summary summary--primary" key={index}>
          <div className="summary-info eq">
            <div className=" summary-info__rect" style={{
              backgroundColor: colorSet.primary,
              border: '1px solid' + colorSet.primary_border
            }}>

            </div>
            <div className="">
              { colorSet.featureName }
            </div>
          </div>
        </div>
      )
    })
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSummaryFeatureColors)
);
